export default __webpack_public_path__ + "static/media/bathroom1-after-480w.aa29777e.png";